// extracted by mini-css-extract-plugin
export default {"searchBox":"clients_searchBox__QTLBt"};